<template>
    <div :class="`x-form-view ${ViewState.getViewMode(viewState)} ${showDefaultForm ? '' : 'expanded'}`">
        <x-form
            ref="form"
            :config="getConfig(config, showDefaultForm)"
            :readonly="readonly"
            :rules="rules"
            v-model:data="modelData"
            @button-click="clickHandler"
            @link-click="linkClickHandler"
            @value-changed="valueChangedHandler"
        >
            <template #field="field">
                <x-form-view v-if="field.config.type == FieldType.FORM"
                    :config="field.config.config"
                    :readonly="field.readonly || field.config.readonly"
                    :query-params="queryParams"
                    :view-state="viewState"
                    @update:data="formDataChangeHandler"
                    class="xm-form"

                    :proxy="proxy"
                    :pcode="getFullCode()"
                ></x-form-view>
                <x-table-view v-else-if="field.config.type == FieldType.TABLE"
                    :config="field.config.config"
                    :readonly="field.readonly || field.config.readonly"
                    :query-params="queryParams"
                    v-model:selected="selected"
                    class="xm-table"

                    :proxy="proxy"
                    :pcode="getFullCode()"
                    :filter-data="filterData"
                    :data="getDefaultTableData(modelData, field.config.field)"
                ></x-table-view>
                <x-tab-view v-else-if="field.config.type == FieldType.TAB && !ViewState.isReadonly(viewState)"
                    :config="field.config"
                    :readonly="field.readonly || field.config.readonly"
                    :query-params="queryParams"
                    :data="tabData"
                    class="xm-tab"
                    :proxy="proxy"
                    :pcode="getFullCode()"
                ></x-tab-view>
                <x-module-view v-else-if="field.config.type == FieldType.PAGE && !ViewState.isReadonly(viewState)"
                    :config="field.config"
                    :readonly="field.readonly || field.config.readonly"
                    :view-state="viewState"

                    :proxy="proxy"
                    :pcode="getFullCode()"
                ></x-module-view>
            </template>
        </x-form>
        <div v-if="viewState == 1 && hasExpand" class="expander" @click="showDefaultForm = !showDefaultForm">
            <el-icon size="small"><ArrowDown/></el-icon><el-icon size="small"><ArrowDown/></el-icon><el-icon size="small"><ArrowDown/></el-icon> <span style="font-size:12px; color: #AAA">{{showDefaultForm ? '展开' : '收起'}}</span> <el-icon size="small"><ArrowDown/></el-icon><el-icon size="small"><ArrowDown/></el-icon><el-icon size="small"><ArrowDown/></el-icon>
        </div>
        <div class="x-bar clearfix" v-if="!readonly && hasButtons(config) && !ViewState.isReadonly(viewState)">
            <x-button-group
                :config="getButtonsConfig(config, viewState)"
                :data="modelData"
                @click="buttonClickHandler"
            ></x-button-group>
        </div>
    </div>
</template>
<script setup>
import { getCurrentInstance, nextTick, onActivated, onMounted, ref, watch } from 'vue';
import { Plus, ArrowDown } from '@element-plus/icons-vue';
import FieldType from '../datamodule/FieldType';
import ViewState from '../viewmodule/ViewState';
import XForm from '../components/data/XForm.vue';
import XButtonGroup from '../components/base/XButtonGroup.vue';
import XTableView from './XTableView.vue';
import XTabView from './XTabView.vue';
import XModuleView from './XModuleView.vue';
import DefaultActions from './actions/DefaultActions';
import { ElMessageBox, ElNotification } from 'element-plus';
import RemoteCenter from '../remoteservice/RemoteCenter';
import { formatDataUrl } from '../remoteservice/RemoteCenter';
import { addURLParams } from '../tools/URLTools';
import { enterPath,enterUrl } from '../router/RouterPath';
import { useRoute, useRouter } from 'vue-router';
import { getRouteCondition, getViewUrl } from '../router/RouterMap';
import { useTokenStore } from '../store/TokenStore';
import ValidateRules from '../rules/ValidateRules';
import { openDialog } from '../dialog/XDialog';
import ModuleCenter from '../datamodule/ModuleCenter';
import ButtonsCode from "../datamodule/ButtonCodes"
import AutoRenew from '../autorenew/AutoRenew';
import { dayjs } from 'element-plus'
import { Clipboard } from 'v-clipboard'
import TimeService from '../remoteservice/TimeService';
import saveResourceRecord from './ResourceRecord';

const inst = getCurrentInstance();
const route = useRoute();
const router = useRouter();
const extData = history.state.ext;
const routeCondition = route ? getRouteCondition(route.path) : null;
const treeInfo = extData?._tree;
// delete extData?._tree;

const tokenStore = useTokenStore();

const selected = ref(null);
const hasExpand = ref(true);
const showDefaultForm = ref(true);

const copyRelations = ref(null);

const getConfig = (config, showDefault)=> {
    const conf = {...config};
    if (props.viewState != 1) return conf;
    const fs = [...config.fields];
    conf.fields = showDefault ? getDefaultFields(fs) : fs;
    return conf;
}
const DEFAULT_FIELD_COUNT = 18;

const getDefaultFields = (fields)=> {
    const fs = fields;
    
    const def = [];
    for (const field of fields) {
        if (field.default) {
            def.push(field);
        }
    }
    if (!def.length) {
        for (const field of fields) {
            def.push(field);
            if (def.length >= DEFAULT_FIELD_COUNT) break;
        }
    }
    hasExpand.value = def.length < fs.length;
    return def;
}

const getDefaultData = ()=> {
    const data = Object.assign({}, extData);
    if (routeCondition) {
        for (const condition of routeCondition) {
            if (condition.type == 1) data[condition.key] = condition.value;
            else if(condition.type == 2) data[condition.key] = condition.value;
        }
    }
    return data;
}
const defaultData = getDefaultData();

const DEF_FORM_BUTTONS = [
    {code:'EDIT', name:'编辑', icon:Plus, state:(ViewState.VIEW)},
    {code:'SAVE', name:'保存', icon:Plus, state:(ViewState.EDIT | ViewState.CREATE)},
    // {code:'HISTORY', name:'历史版本', state:(ViewState.VIEW | ViewState.EDIT)},
]

const props = defineProps({
    config: { default: null },
    readonly: { default: false },
    data: { default: null },

    queryParams: { default: null },
    viewState: { default: null },

    proxy: { default: null },

    pcode: { default: null },
    filterData: { default: null },
})

const getFullCode = ()=> {
    return (props.pcode || '') + (props.config.code ? ('form/' + props.config.code + '/') : '');
}

const getFullCodes = (buttons) => {
 
    if (!buttons.opt) {
        if(!ButtonsCode[buttons.code]){
            console.log(`%c${buttons.code}`,'color: red') 
        }
        return ButtonsCode[buttons.code]||'-'
    } else {
        return buttons.opt
    }
    // return (props.pcode || '') + (props.config.code ? (+ props.config.code + '/') : '');
}


const rules = ref(null);

const getDefaultTableData = (data, field)=> {
    const d = field ? data[field] : data;
    if (d instanceof Array) return d;
    return null;
}

watch(()=> props.config?.fields, (fields)=> {
    if (props.viewState == 1) return;
    rules.value = ValidateRules.getRules(fields, props.config?.view?.getModule());
}, {immediate:true})

const oriData = ref(null);

const updateNodeData = ()=> {
    const node = props.config?.node;
    if (!node) return;
    node.setNodeData({data:modelData.value})
}
const getNodeData = ()=> {
    const node = props.config?.node;
    if (!node) return null;
    return node.getNodeData();
}

const loadData = async (keyData)=> {
    if (!dataView.value || !props.proxy) return null;
    if (!keyData) {
        // if (defaultData) {
            modelData.value = defaultData;
            updateNodeData();
            inst.emit('update:data', defaultData);
            oriData.value = Object.assign({}, defaultData);
        // }
        return null;
    }
    // if (!) return keyData.value;
    updateNodeData();
    const nodeData = getNodeData();
    nodeData.url = props.config?.loadUrl;
    const loadData = await props.proxy.onBeforeLoadData(dataView.value.getCode() || dataView.value.getModuleCode(), nodeData);
    if (loadData) {
        if (loadData.result) {
            
        } else if (loadData.url) {
            loadData.result = props.config?.node?._relations ? await dataView.value?.loadDataWithUrl(loadData.url, keyData, props.viewState) : await dataView.value?.fillData(keyData, props.viewState);
        } else {
            loadData.result = props.config?.node?._relations ? await dataView.value?.loadData(keyData, props.viewState) : await dataView.value?.fillData(keyData, props.viewState);
        }
    } else {
        if (nodeData.url) {
            nodeData.result = props.config?.node?._relations ? await dataView.value?.loadDataWithUrl(nodeData.url, keyData, props.viewState) : await dataView.value?.fillData(keyData, props.viewState);
        }  else {
            nodeData.result = props.config?.node?._relations ? await dataView.value?.loadData(keyData, props.viewState) : await dataView.value?.fillData(keyData, props.viewState);
        }
    }
    let data = loadData || nodeData;
    if (!data.result) return;
    // updateNodeData();
    const resData = await props.proxy?.onAfterLoadData(dataView.value.getCode() || dataView.value.getModuleCode(), data);
    data = resData || data;

    if (props.viewState == ViewState.CREATE) {
        data.result = initCopyData(data.result);
    }
    modelData.value = data.result;
    updateNodeData();
    inst.emit('update:data', data.result);
    // console.log('load data', data);
    oriData.value = Object.assign({}, data.result);
}

const modelData = ref(props.data || {});

const fillData = async()=> {
    if (!dataView.value) return null;
    const data = await dataView.value?.fillData(Object.assign({}, props.data, defaultData), props.viewState);
    modelData.value = data;
    inst.emit('update:data', data);
}

const keyData = ref(null);
watch(()=> props.config?.node?._data, (value)=> {
    if (keyData.value != value) {
        keyData.value = value;
        inst.emit('update:data', value);
    }
    // inst.emit('update:data', value);
}, {immediate:true})
watch(()=> keyData.value, (value)=> {
    if (value) loadData(value);
})
watch(()=>props.proxy, (value)=> {
    if (value) loadData(keyData.value);
})
// watch(()=> keyData, (value)=> {
//     if (value.value) loadData();
// })

onMounted(()=> {
    // const data = props.config?.node?._data;
    // if (data) loadData(data);
    // else fillData();
    if (props.viewState == ViewState.CREATE) fillData();
})
onActivated(()=> {
})

defineEmits({
    'update:data': null,
})

const dataView = ref(null);
watch(()=> props.config?.view, (value)=> {
    dataView.value = value;
}, {immediate:true})

watch(()=>props.data, (value)=> {
    modelData.value = value;
    updateNodeData();
})

const hasButtons = (config)=> {
    return config.buttons && config.buttons.length || config.withDefaultButtons;
}
const getButtonsConfig = (config, viewState)=> {
    let buttons = null;
    if (!config.withDefaultButtons && (!config.buttons || !config.buttons.length)) buttons = null;
    else {
        const actualButtons = config.withDefaultButtons ? DEF_FORM_BUTTONS.slice() : [];
        if (config.buttons && config.buttons.length) {
            for (const btn of config.buttons) {
                for (let i = 0; i < actualButtons.length; i++) {
                    const abtn = actualButtons[i];
                    if (btn.code == abtn.code) {
                        for (const [k, v] of Object.entries(btn)) {
                            if (v === undefined) delete btn[k];
                        }
                        const xbtn = Object.assign({}, abtn, btn);
                        Object.assign(btn, xbtn);
                        actualButtons.splice(i, 1);
                        break;
                    }
                }
            }
        }
        if (config.buttons && config.buttons.length) buttons = actualButtons.concat(config.buttons);
        else buttons = actualButtons.length ? actualButtons : null;
    }
    let viewButtons = null;
    if (buttons) {
        for (const button of buttons) {
            const fullCode = getFullCodes(button);
            button.fullCode = button.code;
            button.opt=fullCode
            button.module=dataView.value.getModuleCode()
            const state = button.state || (ViewState.VIEW | ViewState.EDIT | ViewState.CREATE);
            if ((state & viewState) > 0) {
                if (!viewButtons) viewButtons = [];
                viewButtons.push(button);
            }
        }
    }
    return {align:'right', grouped:false, buttons:viewButtons};
}

const invalidData = async (data, view)=> {
    // if ((await ElMessageBox.confirm('是否取消？', '提示：', {confirmButtonText:'是', cancelButtonText:'否'})) == 'cancel') return;
    data.orderStatus = 'canceled';
    return saveData(data, view);
}
const closeData = async (data, view)=> {
    // if ((await ElMessageBox.confirm('是否关闭？', '提示：', {confirmButtonText:'是', cancelButtonText:'否'})) == 'cancel') return;
    data.orderStatus = 'closed';
    return saveData(data, view);
}
const closeDataContract = async (data, view)=> {
    // if ((await ElMessageBox.confirm('是否关闭？', '提示：', {confirmButtonText:'是', cancelButtonText:'否'})) == 'cancel') return;
    data.contractStatus = 'closed';
    return saveData(data, view);
}
const deleteData = async (data, view)=> {
    if (!view) return;
    view.deleteDatas([data]);
}
const lockData = async (data, view)=> {
    const key = view.dataKey(data,'id');
    const d = view.do('/dev-api/lms/' + view.getModuleCode() + '/lock/' + '1/' + key,{});
    if (d) data.lockStatus = '1';
    return d;
}
const unlockData = async (data, view)=> {
    const key = view.dataKey(data,'id');
    const d = view.do('/dev-api/lms/' + view.getModuleCode() + '/lock/' + '0/' + key,{});
    if (d) data.lockStatus = '0';
    return d;
}
const toVoucherImpNum = async (data, view) => {
    const key = view.dataKey(data,'id');
    const code = view.getModuleCode();
   const d = view.do('/dev-api/lms/' + code + '/finsConfirm', {ids: key.toString(), type: '1' });
   return d;
    
}
const modifySaveData = async (data, view, modify)=> {
    // data = Object.assign(data, modify);
    for (const [k, v] of Object.entries(modify)) {
        let value = v;
        if (v == '{loginUser}') value = tokenStore.userid;
        else if (v == '{now}') value = dayjs(TimeService.getServerTimeStamp()).format('YYYY-MM-DD HH:mm:ss');
        data[k] = value;
    }
    const result = await view.saveData(data);
    if (result) {
        modelData.value = result;
        inst.emit('update:data', result);
        oriData.value = Object.assign({}, result);
        modelData.value = result;
    }
    return true;
}
const saveDataWithTree = async (data, view, tree)=> {
    console.log(tree);
    
    return true;
}
const saveData = async (data, view, tree)=> {
    const valid = await inst.refs.form['validateForm']();
    if (!valid) {
        ElNotification({message:'数据校验失败，请检查数据准确性', title:'提示：', type:'warning'});
        return;
    }
    updateNodeData();
    const isCreate = view.dataKey(data, 'id') == null;
    const nodeData = getNodeData();
    nodeData.url = props.config?.saveUrl;
    let relations = null;
    if (tree) {
        relations = ModuleCenter.testRelations([view.getModule().getCode(), tree.module]);
        if (relations.length == 1) {
            const relation = view.getModule().getModuleRelation(tree.module);
            nodeData.data[relation.srcField] = tree.data[relation.destField];
        }
    }
    const saveData = isCreate ? (await props.proxy?.onBeforeCreateData(dataView.value.getCode() || dataView.value.getModuleCode(), nodeData)) : (await props.proxy?.onBeforeEditData(dataView.value.getCode() || dataView.value.getModuleCode(), nodeData));
    if (saveData) {
        if (saveData.result) {
            
        } else if (saveData.url) {
            saveData.result = await view.saveDataWithUrl(saveData.url, saveData.data);
        } else {
            saveData.result = await view.saveData(saveData.data);
        }
    } else {
        if (nodeData.url) {
            nodeData.result = await view.saveDataWithUrl(nodeData.url, nodeData.data);
        } else {
            nodeData.result = await view.saveData(nodeData.data);
        }
    }
    let res = saveData || nodeData;
    if (!res.result) return false;
    updateNodeData();
    const resData = isCreate ? (await props.proxy?.onAfterCreateData(dataView.value.getCode() || dataView.value.getModuleCode(), res)) : (await props.proxy?.onAfterEditData(dataView.value.getCode() || dataView.value.getModuleCode(), res));
    res = resData || res;

    if (res.result) {
        modelData.value = res.result;
        inst.emit('update:data', res.result);
        oriData.value = Object.assign({}, res.result);
        modelData.value = res.result;
    }
    if (copyRelations.value) {
        const {ori, rels} = copyRelations.value;
        const relModules = rels;
        console.log(ori, rels);
        for (const relModule of relModules) {
            const relations = ModuleCenter.testRelations([view.getModule().getCode(), relModule]);
            if (relations.length == 1) {

            } else if (relations.length == 2) {
                let key = '';
                let field = '';
                let relKey = '';
                let relField = '';
                let rModule = '';
                relations[0].dest.replace(/^(\w+)\.(\w+)$/, ($0, $1, $2)=> {
                    rModule = $1;
                    key = $2;
                })
                relations[0].src.replace(/^\w+\.(\w+)$/, ($0, $1)=> {
                    field = $1;
                })
                relations[1].src.replace(/^\w+\.(\w+)$/, ($0, $1)=> {
                    relKey = $1;
                })
                relations[1].dest.replace(/^\w+\.(\w+)$/, ($0, $1)=> {
                    relField = $1;
                })
                const keys = [ori[field] + ''];
                const query = {};
                query[key] = keys;
                const module = ModuleCenter.getModule(rModule);
                const relDatas = await module.queryDatas({query});
                const rDatas = [];
                for (const relData of relDatas) {
                    const rData = {};
                    rData[relKey] = relData[relKey];
                    rData[key] = modelData.value[field];
                    rDatas.push(rData);
                }
                await module.createDatas(rDatas);
                console.log(rDatas);
            }
        }
    }
    if (tree) {
        if (relations.length == 2) {
            let key = '';
            let field = '';
            let relKey = '';
            let relField = '';
            let rModule = '';
            relations[0].dest.replace(/^(\w+)\.(\w+)$/, ($0, $1, $2)=> {
                rModule = $1;
                key = $2;
            })
            relations[0].src.replace(/^\w+\.(\w+)$/, ($0, $1)=> {
                field = $1;
            })
            relations[1].src.replace(/^\w+\.(\w+)$/, ($0, $1)=> {
                relKey = $1;
            })
            relations[1].dest.replace(/^\w+\.(\w+)$/, ($0, $1)=> {
                relField = $1;
            })

            const rData = {};
            rData[key] = modelData.value[field];
            rData[relKey] = tree.data[relField];
            const module = ModuleCenter.getModule(rModule);
            await module.createData(rData);
            console.log(rData);
        }
    }
    // await loadData(modelData.value);
    return true;
}
const addTargetDatas = async (dataForm, view, targetModule, targetMap, sourceDialog)=> {
    if (!view) return null;
    const res = await openDialog({config:sourceDialog})
    if (!res) return null;
    const relModule = res.module;
    const relation = ModuleCenter.getModule(targetModule).getModuleRelation(relModule);
    const cRelation = view.getModule().getModuleRelation(targetModule);
    const datas = [];
    for (const d of res.data) {
        const data = {};
        data[relation.srcField] = d[relation.destField];
        data[cRelation.destField] = dataForm[cRelation.srcField];
        if (targetMap){
            for (const [mapField, field] of Object.entries(targetMap)) {
                data[mapField] = dataForm[field];
            }
        }
        datas.push(data);
    }
    const r = await ModuleCenter.getModule(targetModule).createDatas(datas);
    console.log(r);
    return r;
}
const goNext = async (data, view)=> {
    await compareSave();
    const filter = routeCondition ? [...routeCondition] : [];
    if (extData) {
        for (const [key, value] of Object.entries(extData)) {
            filter.push({key:key, value:value, type:1});
        }
    }
    const next = await view.getNextData(data, filter);
    if (!next) {
        ElMessageBox.alert('已经没有下一条数据。', '提示：');
    } else {
        const key = view.dataKey(next);
        DefaultActions.doReplace(props.viewState, view.getModuleCode(), null, key);
        nextTick(()=> {
            loadData(next);
        })
    }
}
const goLink = async (data, view, config)=> {
    const urlInfo = formatDataUrl(config.url, data);
    router.push({path:urlInfo.url, query:urlInfo.params});
    // console.log(url);
}
const goView = async (data, view)=> {
    const key = view.dataKey(data);
    DefaultActions.doReplace(ViewState.VIEW, view.getModuleCode(), null, key);
}
const goEdit = async (data, view)=> {
    const key = view.dataKey(data);
    DefaultActions.doReplace(ViewState.EDIT, view.getModuleCode(), null, key);
}
const goHistory=(data,view)=>{
     const url=`/contrast/index?module=${view.getModuleCode()}&key=${view.dataKey(data, 'id')}&state=''`
     enterPath(url);
}
const goCopy = async (data, view, fields, rels)=> {
    const key = view.dataKey(data);
    DefaultActions.doReplace(ViewState.CREATE, view.getModuleCode(), null, key, {fields:fields?.join(',') || '', rels:rels?.join(',') || ''});
}
const copyLink = async (data, view, nameField)=> {
    const url = getViewUrl(data, view.getModuleCode());
    const name = data[nameField || 'name'];
    const link = `${url}\n#${name || ''}#`;
    await Clipboard.copy(link);
}
const doExam = (data, view) => {
    const startTime = (new Date(data.startTim)).getTime();
    if (startTime > TimeService.getServerTimeStamp()) {
        ElMessageBox.alert(`考试尚未开始，当前时间为${TimeService.getServerTimeStr()}，请稍候...`, '提示：')
        return;
    }

    // TableApi.postMethods('/dev-api/lms/answerPaper/startTheExam',{examId:107,examPaperId:110,isResit:'yes'})
    // let index = routeCondition.findIndex(it => it.key == 'srcEntityType')
    // if (index == -1) return
    // const url = `/#/do/index?token=${btoa(data.examId + ':' + data.questionPaperId)}&state=no`
    // console.log(url, window.location,window.location.origin + url)
    // window.open(window.location.origin + url,)
    enterUrl('/do/index', {token:btoa(data.examId + ':' + data.questionPaperId), state:'no'});
}
const initCopyData = (data)=> {
    const view = dataView.value;
    const fields = view.getFormFields().concat(extData.fields.split(',').map(field => {
        return { field };
    }));
    const keyFields = view.keyFields();
    const d = {}
    for (const field of fields) {
        const f = field.field;
        if (keyFields.indexOf(f) < 0) d[f] = data[f];
    }
    if (extData?.rels) copyRelations.value = {ori:data, rels:extData.rels.split(',')};
    return d;
}

const clickHandler = (button, data, config)=> {
}

const compareSave = async ()=> {
    if (!dataView.value.compareData(oriData.value, modelData.value)) {
        if ((await ElMessageBox.confirm('数据已变更，是否保存？', '提示：', {confirmButtonText:'是', cancelButtonText:'否'})) == 'cancel') return;
        saveData(modelData.value, dataView.value);
    }
}

const processDefaultAction = async (action, data, config)=> {
    if (!config) return;
    if (config.needSave) await compareSave();
    if (config.link) {
        //'/contract/view/?module=fmpContract.id&key={contractId}&state=1'
        const urlInfo = formatDataUrl(config.link, data);
        const url = addURLParams(urlInfo.url, Object.assign({}, urlInfo.params, urlInfo.body));
        enterPath(url);
        return;
    }
    if (config.dialog) {
        const res = await openDialog(config.dialog, config.dialogComponent, data);
        if (!res) return;
        if (config.dialog.dataField) {
            data[config.dialog.dataField] = res['data'];
        } else if (config.dialog.valueField) {
            data[config.dialog.valueField] = res['selected'];
        } else if (config.dialog.fieldMap) {
            const d = res['data'];
            if (d instanceof Array) {
                for (const [mapField, field] of Object.entries(config.dialog.fieldMap)) {
                    const values = [];
                    for (const da of d) {
                        values.push(da[field]);
                    }
                    data[mapField] = values;
                }
            } else {
                for (const [mapField, field] of Object.entries(config.dialog.fieldMap)) {
                    data[mapField] = d[field];
                }
            }
        }
        //Object.assign(data, await DialogManager.showDialog(config.dialog));
    }
    const url = config.url;
    const actionData = {};
    if (config.map) {
        for (const [mapField, field] of Object.entries(config.map)) {
            actionData[mapField] = data[field];
        }
    } else {
        Object.assign(actionData, data);
    }
    const {type, loadingState} = config;
    const urlInfo = formatDataUrl(url, actionData);
    const res = await RemoteCenter.remoteCall(urlInfo.url, Object.assign({}, urlInfo.params, urlInfo.body, actionData), {type, loadingState:config.loadingState || 0});
    if (res != -1 && config.success) {
        ElNotification({
            title: '提示',
            message: config.success,
            type: 'success',
        })
    }
    if (config.reset && res.data) {
        modelData.value = res.data;
        inst.emit('update:data', res.data);
        dataView.value._module._dataInfo.updateDatas([res.data]);
        oriData.value = Object.assign({}, res.data);
        modelData.value = res.data;
    }
    if (config.refresh) {
        // await loadData(modelData.value);
    }
    if (config.goView) {
        goView(modelData.value, dataView.value)
    }
}

const buttonClickHandler = async (button)=> {
    updateNodeData();
    const config = button.config;
    const action = button.action || button.code;
    const actionData = await props.proxy?.onAction(dataView.value.getCode() || dataView.value.getModuleCode(), getNodeData(), action, treeInfo, extData);
    if (actionData) {
        if(actionData.needSave) await compareSave();
        // 结果填充数据
    } else {
        if (config && config.confirm && (await ElMessageBox.confirm(config.confirm, '提示：', {confirmButtonText:'是', cancelButtonText:'否'})) == 'cancel') return;
        const data = modelData.value;
        switch (action) {
            case 'SAVEWITHTREE':
                // console.log('-343-------')
                const td = await saveDataWithTree(data, dataView.value, treeInfo ? JSON.parse(treeInfo) : null);
                if (td) goView(modelData.value, dataView.value);
                break;
            case 'SAVE':
                let saveKey = null;
                if (button.code == 'SAVE_RESOURCE') {
                    saveKey = dataView.value.dataKey(data);
                }
                if (button.code == 'SAVE_CHAPTER') {
                    saveKey = dataView.value.dataKey(data);
                }
                const d = await saveData(data, dataView.value, treeInfo && config?.tree ? JSON.parse(treeInfo) : null);
                if (button.code == 'SAVE_RESOURCE') {
                    saveResourceRecord(modelData.value, 'update', saveKey == null ? '创建' : '修改');
                }
                if (button.code == 'SAVE_CHAPTER') {
                    saveResourceRecord(modelData.value, 'update', saveKey == null ? '创建' : '修改');
                }
                if (d) goView(modelData.value, dataView.value);
                break;
            case 'MODIFY_SAVE':
                const md = await modifySaveData(data, dataView.value, config.modify);
                if (md && config.alert) ElMessageBox.alert(config.alert, '提示：');
                else if (button.code == 'PASS') {
                    await saveResourceRecord(data, 'approve', '审核通过');
                    ElMessageBox.alert('发布成功！', '提示：');
                } else if (button.code == 'REFUSE') {
                    await saveResourceRecord(data, 'approve', '审核通过');
                    ElMessageBox.alert('审核已拒绝通过！', '提示：');
                }
                break;
            case 'HISTORY':
                goHistory(modelData.value, dataView.value);
                break;
            case 'EDIT':
                goEdit(modelData.value, dataView.value);
                break;
            case 'INVALID':
                await invalidData(data, dataView.value);
                break;
            case 'CLOSE':
                await closeData(data, dataView.value);
                break;
            case 'CLOSECONTRACT':
                await closeDataContract(data, dataView.value);
                break;
            case 'DELETE':
                if ((await ElMessageBox.confirm('是否删除当前数据？', '提示：', {confirmButtonText:'是', cancelButtonText:'否', type:'warning'})) == 'cancel') return;
                await deleteData(data, dataView.value);
                break;
            case 'NEXT':
                goNext(data, dataView.value);
                break;
            case 'COPYLINK':
                copyLink(data, dataView.value, config?.nameField);
                ElMessageBox.alert('链接已复制到剪贴板');
                break;
            case 'DOEXAM':
                await doExam(data, dataView.value);
                break;
            case 'COPY':
                goCopy(data, dataView.value, config?.fields, config?.rels);
                break;
            case 'LOCK':
                lockData(data, dataView.value);
                break;
            case 'UNLOCK':
                unlockData(data, dataView.value);
                break;
            case 'FINANCENPIMPNUM':
                await toVoucherImpNum(data, dataView.value);
                break;
            case 'ADDTARGETDATAS':
                const tasks = await addTargetDatas(data, dataView.value, config?.target, config?.targetMap, config?.source);
                if (tasks) ElMessageBox.alert('下发任务成功！');
                break;
            case 'LINK':
                goLink(data, dataView.value, config);
                break;
            default: 
                processDefaultAction(action, data, config);
                break;
        }
    }
}
const linkClickHandler = (value, data, config)=> {
    if (config.path) {
        const relInfo = config.path[config.path.length - 1];
        const field = config.path[config.path.length - 2].field._relFieldCode;
        DefaultActions.doEnter(ViewState.VIEW, relInfo.module.getCode(), field, value);

    } else {
        const dataView = props.config?.view;
        const dataField = dataView.getDataField(config.field);
        let relInfo = dataField.getRelatedInfo();
        if (!relInfo && dataField._dynamicRelInfo && dataField._dynamicRelInfo.length) {
            const typeField = dataView.getModule()._bindEntity.typeField;
            const dynamicModule = data[typeField];
            relInfo = dataField.getDynamicRelatedInfoBy(dynamicModule);
        }
        DefaultActions.doEnter(ViewState.VIEW, relInfo.module.getCode(), relInfo.field.getCode(), value);
    }
}
const tabData = ref(null);
const formDataChangeHandler = (value)=> {
    tabData.value = value;
}

const validateForm = async ()=> {
    return await inst.refs.form['validateForm']();
}

const valueChangedHandler = (value, config)=> {
    AutoRenew.update();
    if (config.map) {
        if (value != null) {
            const module = ModuleCenter.getModule(config.targetModule);
            if (!module) return;
            if (value instanceof Array) {
                let datas = module.getDatasLocal(value, config.targetField);
                if (!datas) datas = [];
                for (const [mapField, field] of Object.entries(config.map)) {
                    let fs = modelData.value[mapField];
                    if (!fs) fs = modelData.value[mapField] = [];
                    for (const data of datas) {
                        fs.push(data[field])
                    }
                }
            } else {
                let data = module.getDataLocal(value, config.targetField);
                if (!data) data = null; 
                for (const [mapField, field] of Object.entries(config.map)) {
                    modelData.value[mapField] = data[field];
                }
            }
        } else {
            for (const [mapField, field] of Object.entries(config.map)) {
                modelData.value[mapField] = null;
            }
        }
    }
    // console.log('form value changed', value, config);
}
defineExpose({
    validateForm
})

</script>
<style scoped>
.x-form-view.xm-form {
    margin-top: 10px;
}
.xm-form {
    padding: 20px 10px 5px 10px;
    background: #fff;
    /* margin-bottom: 10px; */
}
.x-form-view.view >>> .el-form-item {
    margin: 0;
    padding: 6px;
}
.x-bar {
    padding: 5px;
}
.x-bar .clearfix{
    float: right;
}
.xm-tab {
    background: #fff;
    padding: 10px 10px;
    margin-top: 10px;
}
.x-form-view >>> .expander {
    cursor: pointer;
    line-height: 20px;
    text-align: center;
    background: #f5f7fa;
}
.x-form-view.expanded >>> .expander .el-icon {
    transform: rotate(180deg);;
}
.x-form-view >>> .el-form-item__label {
    /*justify-content: left;*/
}
</style>